import { Formik } from "formik";
import * as yup from "yup";
import React, { Component } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import { NotificationManager } from "react-notifications";
import { addMarkUp } from "app/services/markUpService";
import { useState } from "react";
import { useEffect } from "react";
import { addAirport } from "app/services/SearchService";

const airportSchema = yup.object().shape({
  cityCode: yup.string().required("City Code is required"),
  cityName: yup.string().required("City Name is required"),
  countryCode: yup.string().required("Country Code is required"),
  airportType: yup.string().required("Airport Type is required"),
  airportName: yup.string().required("Airport Name is required"),
});

function AddAirports({
  handleClose,
  handleShow,
  editId,
  show,
  editRow,
  loadAirport,
}) {
  const [isShow, setIsShow] = useState(false);
  const airport = {
    cityCode: "",
    cityName: "",
    countryCode: "",
    airportType: "",
    airportName: "",
  };
  const [state, setState] = useState(airport);

  const airportTypeOptions = [
    { value: "domestic", label: "Domestic" },
    { value: "International", label: "International" },
  ];

  const handleSubmit = async (values) => {
    debugger;
    setIsShow(true);
    const response = await addAirport(values);
    console.log(response);
    try {
      if (response.status == "Success") {
        {
          values?.id > 0
            ? NotificationManager.success(
                "Airport Information Update successfully"
              )
            : NotificationManager.success(
                "Airport Information Add successfully"
              );
        }
        loadAirport();
        // document.querySelectorAll(".btn-close")[0].click();
        handleClose();
        setIsShow(false);
      } else {
        setIsShow(false);
        loadAirport();
        NotificationManager.success("Something went wrong");
        // document.querySelectorAll(".btn-close")[0].click();
        handleClose();
      }
    } catch (error) {
      setIsShow(false);
      loadAirport();
      NotificationManager.error("something went to be wrong");
      // document.querySelectorAll(".btn-close")[0].click();
      handleClose();
      console.log(error);
      throw error;
    }
  };
  // const closeModal = (resetForm) => {
  //   debugger;
  //   setState(editRow);
  //   resetForm();
  //   // setState(airport);
  //   handleClose();
  // };
  useEffect(() => {
    if (editRow) {
      setState(editRow);
    } else {
      setState(airport);
    }
  }, [editRow]);

  return (
    <div>
      <Formik
        initialValues={state}
        validationSchema={airportSchema}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          isSubmitting,
        }) => (
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {values?.id > 0 ? "Update Airport" : "Add Airport"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={handleSubmit} className="p-3">
                <Form.Group>
                  <RenderSelectInput
                    type="text"
                    display="Airport Type"
                    name="airportType"
                    value={values?.airportType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors?.airportType}
                    touched={touched?.airportType}
                    items={airportTypeOptions}
                    required
                  ></RenderSelectInput>
                </Form.Group>
                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="Country Code"
                    placeholder="Enter Country Code"
                    name="countryCode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    error={errors.countryCode}
                    value={values?.countryCode}
                    touched={touched.countryCode}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="Airport Code"
                    placeholder="Enter Airport Code"
                    name="cityCode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.cityCode}
                    error={errors.cityCode}
                    autoComplete="off"
                    touched={touched.cityCode}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="City Name"
                    placeholder="Enter City Name"
                    name="cityName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    error={errors.cityName}
                    value={values?.cityName}
                    touched={touched.cityName}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <RenderTextInput
                    type="text"
                    display="Airport Name"
                    placeholder="Enter Airport Name"
                    name="airportName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.airportName}
                    value={values?.airportName}
                    autoComplete="off"
                    touched={touched.airportName}
                    required
                  />
                </Form.Group>

                <Row>
                  <div className="m-auto text-center">
                    {isShow ? (
                      <Button variant="primary" size="md" disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          style={{ marginRight: "10px" }}
                        />
                        {values?.id > 0 ? "Updating..." : "Adding..."}
                      </Button>
                    ) : (
                      <Button variant="primary" size="md" type="submit">
                        {values?.id > 0 ? "Update Airport" : "Add Airport"}
                      </Button>
                    )}
                  </div>
                </Row>
              </form>
            </Modal.Body>
          </Modal>
        )}
      </Formik>
    </div>
  );
}

export default AddAirports;
